module.exports = __webpack_public_path__ + "static/media/mn.39952937.svg";